// Extracts the portal-api / marketing-api error text from a refine HttpError. Nest puts the machine code (or the joined
// validation messages) in `message`; the console maps known codes to translated texts and falls back to the raw text.
export const getSaSmsErrorCode = (error: unknown): string => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- axios error shape is untyped
    const body = (error as any)?.response?.data;
    const raw = body?.message ?? body?.error ?? (error as Error)?.message ?? 'unknown';
    return Array.isArray(raw) ? raw.join('; ') : String(raw);
};
